import { KeyValuePair } from './../shared/key-value-pair';

export enum SelectionType {
  Visits,
  People,
  Audience,
  Backoffice,
  Customers,
  Accounts,
}

export const SEARCHKEYS: KeyValuePair<string>[] = [
  { key: 'goals', value: 'Goals' },
  { key: 'campaigns', value: 'CampaignName' },
  { key: 'notGoals', value: 'not-Goals' },
  { key: 'notCampaigns', value: 'not-CampaignName' },
  { key: 'profilings', value: 'ValidProfilings' },
  { key: 'visitedPages', value: 'VisitedPages' },
  { key: 'labels', value: 'Labels' },
  { key: 'country', value: 'country_code' },
  { key: 'referrer_type', value: 'referrer_type' },
  { key: 'referrer_domain', value: 'referrer_domain' },
  { key: 'utmMedium', value: 'CampaignMedium' },
  { key: 'utmSource', value: 'CampaignSource' },
  { key: 'referrerURL', value: 'referrer_url' },
  { key: 'browserLang', value: 'AcceptLanguage' },
  { key: 'device', value: 'screen_resolution' },
  { key: 'siteTime', value: 'time_total' },
  { key: 'totalVisits', value: 'total_visits' },
  { key: 'totalVisitsPeople', value: 'TotalVisits' },
  { key: 'pageViews', value: 'NumberOfPageviews' },
  { key: 'identified', value: 'HasVisitor' },
  { key: 'socialMedia', value: 'social media' },
  { key: 'paidTraffic', value: 'advertising' },
  { key: 'emailCampaigns', value: 'email' },
  { key: 'TextSearch', value: 'TextSearch' },
  { key: 'consent', value: 'consentVersions' },
  { key: 'accepted', value: 'acceptedVersions' },
  { key: 'widget-opens', value: 'WidgetOpen' },
  { key: 'widget-dissmissals', value: 'WidgetDismissal' },
  { key: 'widget-clickthroughs', value: 'WidgetClickThrough' },
  { key: 'widget-conversions', value: 'WidgetConversion' },
  { key: 'widget-survey-response', value: 'WidgetSurveyResponse' },
  { key: 'widget-copy-coupon', value: 'WidgetCopyCoupon' },
  { key: 'nps-score', value: 'NpsScores' },
  { key: 'csat-score', value: 'CsatScores' },
];
